var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 46,
    viewBox: "0 0 38 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7625 13.9216L38 0H0V46H17.1493V35.3648L31.0543 35.4902L34.2952 21.5685H17.1493V13.9216H34.7625ZM35.1519 2.26324L32.9677 11.6584H17.1493V2.26324H35.1519ZM14.8871 2.26324V9.8932L5.77061 2.26324H14.8871ZM4.70047 23.8318H14.8871V32.1698L4.70047 23.8318ZM2.27573 43.7368V25.5123L14.9006 35.4563V43.7368H2.27573ZM31.4606 23.8318L29.273 33.2269H17.1493V23.8318H31.4606ZM2.61438 21.5685H2.27573V2.27679L14.9006 12.8442V21.5685H2.61438Z",
    fill: "#EC333B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.3a4234d5.svg";
export { ForwardRef as ReactComponent };